module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/book/book-send/first-step/selected-user-list/selected-user-list.component.scss
// module id = ./src/app/book/book-send/first-step/selected-user-list/selected-user-list.component.scss
// module chunks = main